import { BellOutlined } from '@ant-design/icons';
import { Badge, Dropdown, MenuProps } from 'antd';
import React from 'react';
import { AlertItem } from '../../interfaces/alert';
import AlertBar from '../AlertBar/AlertBar';
import './NotificationBell.less';

interface NotificationBellProps {
  alerts: AlertItem[];
}

const NotificationBell: React.FC<NotificationBellProps> = ({ alerts }) => {
  // Get the highest priority alert for the badge
  const highestPriorityAlert = alerts[0];
  const badgeType = highestPriorityAlert?.type || 'default';

  // Create alert items for the dropdown
  const alertItems = alerts.map((alert) => ({
    key: alert.id,
    label: (
      <div className="alert-dropdown-item">
        <AlertBar message={alert.message} type={alert.type} />
      </div>
    ),
  }));

  const items: MenuProps['items'] = [
    ...(alertItems.length > 0 ? alertItems : []),
    ...(alertItems.length === 0
      ? [
          {
            key: 'no-alerts',
            label: 'No notifications',
            disabled: true,
          },
        ]
      : []),
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <Badge count={alerts.length} color={badgeType} size="small">
        <BellOutlined className="notification-bell-icon" />
      </Badge>
    </Dropdown>
  );
};

export default NotificationBell;
